import { render, staticRenderFns } from "./KpiTemplate.vue?vue&type=template&id=599148a6"
import script from "./KpiTemplate.vue?vue&type=script&lang=js"
export * from "./KpiTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports